import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './contexts/AuthContext';
import { PermissionsProvider } from './hooks/usePermissions';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Pacientes from './pages/Pacientes';
import Medicos from './pages/Medicos';
import Consultas from './pages/Consultas';
import Exames from './pages/Exames';
import Farmacia from './pages/Farmacia';
import Medicamentos from './pages/Medicamentos';
import Relatorios from './pages/Relatorios';
import ContasReceberPage from './pages/Financeiro/ContasReceberPage';
import ContasPagarPage from './pages/Financeiro/ContasPagarPage';
import RelatorioFinanceiroPage from './pages/Financeiro/RelatorioFinanceiroPage';
import Fornecedores from './pages/Fornecedores';
import Configuracoes from './pages/Configuracoes';
import GerenciarUsuarios from './pages/GerenciarUsuarios';
import Agendamentos from './pages/Agendamentos';
import Atendimento from './pages/Atendimento';
import ContatoBiobruna from './pages/ContatoBiobruna';
import ContatoBioClinica from './pages/ContatoBioClinica';
import './styles/globals.css';
import 'react-toastify/dist/ReactToastify.css';

// Configuração do React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutos
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <PermissionsProvider>
          <Router>
            <div className="App">
              <Routes>
                {/* Rota pública de login */}
                <Route path="/login" element={<Login />} />
                {/* Rota pública para contato WhatsApp bio Bruna */}
                <Route path="/contatobiobruna" element={<ContatoBiobruna />} />
                {/* Rota pública para contato WhatsApp bio Clinica */}
                <Route path="/contatobioclinica" element={<ContatoBioClinica />} />
                {/* Rotas protegidas com Layout como wrapper */}
                <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
                  <Route path="dashboard" element={<Dashboard />} />
                  <Route path="pacientes" element={<Pacientes />} />
                  <Route path="medicos" element={<Medicos />} />
                  <Route path="consultas" element={<Consultas />} />
                  <Route path="exames" element={<Exames />} />
                  <Route path="farmacia" element={<Farmacia />} />
                  <Route path="medicamentos" element={<Medicamentos />} />
                  <Route path="relatorios" element={<Relatorios />} />
                  <Route path="configuracoes" element={<Configuracoes />} />
                  <Route path="gerenciar-usuarios" element={<GerenciarUsuarios />} />
                  <Route path="fornecedores" element={<Fornecedores />} />
                  <Route path="agendamentos" element={<Agendamentos />} />
                  <Route path="atendimento/:consultaId" element={<Atendimento />} />
                  <Route path="financeiro/contas-receber" element={<ContasReceberPage />} />
                  <Route path="financeiro/contas-pagar" element={<ContasPagarPage />} />
                  <Route path="financeiro/relatorios" element={<RelatorioFinanceiroPage />} />
                  {/* Redirecionamento padrão */}
                  <Route index element={<Navigate to="/dashboard" replace />} />
                  <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Route>
              </Routes>
              {/* Toast notifications */}
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
              />
            </div>
          </Router>
        </PermissionsProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;